import LoginComponent from "../components/Login/Login";
import { UserGuard } from "../Guard/UserGuard";
const Login = () => (
  <UserGuard>
    <LoginComponent />
  </UserGuard>
);

export default Login;
